import { isNullOrUndefined } from "../../utils";

export function getProgressSummary(item, hasOperationEventsEnabled) {
  const summary = {
    completedCount: 0,
    startedCount: 0,
    enabledCount: 0,
    notCompletedCount: 0,
  };

  // Depending on what mode we are in summarize progress differently
  if (hasOperationEventsEnabled && !isNullOrUndefined(item?.eventSummary)) {
    // Summarize progress based on operation events
    summary.completedCount = item.eventSummary.completedCount;
    summary.enabledCount = item.eventSummary.totalCount;
    summary.notCompletedCount = summary.enabledCount - summary.completedCount;
  } else if (
    !hasOperationEventsEnabled &&
    !isNullOrUndefined(item?.operationSummary)
  ) {
    // Summarize progress based on operation
    summary.completedCount = item.operationSummary.completedCount;
    summary.startedCount = item?.operationSummary.startedCount;
    summary.enabledCount = item.operationSummary.enabledCount;
    summary.notCompletedCount =
      summary.enabledCount - summary.startedCount - summary.completedCount;
  }
  return summary;
}
